import classNames from 'classnames';
import React from 'react';
import { Td as ResponsiveTd } from 'react-super-responsive-table';
import styles from './index.module.scss';
import type { CommonCellProps } from './utils';

export interface TdProps extends React.HTMLAttributes<HTMLTableDataCellElement>, CommonCellProps {
  colSpan?: number;

  columnKey?: number;

  /**
   * Wrap contents vertically (into rows).
   * @deafult false
   */
  vertical?: boolean;
}

export const Td: React.FC<TdProps> = props => {
  const {
    centered,
    children,
    className,
    columnKey,
    innerClass,
    numeric,
    rightAligned,
    vertical,
    ...rest
  } = props;
  const containerClass = classNames(
    styles.td,
    {
      [styles.numeric]: numeric,
      [styles.centered]: centered,
      [styles.rightAligned]: rightAligned,
      [styles.vertical]: vertical,
    },
    className
  );

  return (
    <ResponsiveTd {...rest} className={containerClass} columnKey={columnKey}>
      <div className={classNames(styles.inner, innerClass)}>{children}</div>
    </ResponsiveTd>
  );
};
